import React from "react";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import PublicLayout from "../../layouts/PublicLayout";
import PrivateLayout from "../../layouts/PrivateLayout";
import useLanguage from "../../utils/useLanguage";
import "@fortawesome/fontawesome-free/css/all.min.css";

const quickLinks = [
  {
    to: "/shop",
    icon: "fas fa-store",
    labelEn: "Shop",
    labelBg: "Магазин",
    descEn: "Browse official Terra guild merch.",
    descBg: "Разгледай официалните стоки на гилдия Тера.",
  },
  {
    to: "/tournaments",
    icon: "fas fa-trophy",
    labelEn: "Tournaments",
    labelBg: "Турнири",
    descEn: "Active and past tournament brackets.",
    descBg: "Активни и минали турнири.",
  },
  {
    to: "/solo-duo-ranking",
    icon: "fas fa-medal",
    labelEn: "Solo/Duo Ranking",
    labelBg: "Соло/Дуо Класация",
    descEn: "Ladder standings and registration.",
    descBg: "Класиране и регистрация.",
  },
  {
    to: "/raid-signups",
    icon: "fas fa-shield-halved",
    labelEn: "Raid Sign-Up",
    labelBg: "Записване за Рейд",
    descEn: "Join the roster for the next raid season.",
    descBg: "Присъедини се към състава за следващия сезон.",
    highlight: true,
  },
];

function Landing() {
  const { lang } = useLanguage();
  const isLoggedIn = !!Cookies.get("jwt");

  const content = (
    <div className="min-h-full flex flex-col items-center px-4 sm:px-6 lg:px-8 py-14 text-white bg-black/40">
      <div className="max-w-4xl w-full text-center mb-12">
        <img src="/new-logo-terra.png" alt="Terra" className="h-16 w-16 mx-auto mb-4 drop-shadow-lg" />
        <h1 className="text-3xl sm:text-5xl font-bold font-serif tracking-wide mb-4">TERRA</h1>
        <p className="text-gray-300 text-base sm:text-lg max-w-xl mx-auto">
          {lang === "bg"
            ? "Гилдия Тера — турнири, класации, рейдове и магазин, всичко на едно място."
            : "Guild Terra — tournaments, rankings, raids, and the shop, all in one place."}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-4xl w-full">
        {quickLinks.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={`relative flex items-start space-x-4 rounded-xl p-5 border transition-all duration-300 ${
              link.highlight
                ? "bg-emerald-500/10 border-emerald-500/40 hover:border-emerald-400 hover:bg-emerald-500/15 shadow-[0_0_20px_-6px_rgba(16,185,129,0.6)]"
                : "bg-gray-900/70 border-gray-700 hover:border-blue-600 hover:bg-gray-900/90"
            }`}
          >
            {link.highlight && (
              <span className="absolute inset-0 rounded-xl bg-emerald-400 opacity-10 animate-ping-slow pointer-events-none"></span>
            )}
            <div
              className={`flex-shrink-0 w-11 h-11 rounded-lg flex items-center justify-center ${
                link.highlight ? "bg-emerald-500/20" : "bg-blue-600/20"
              }`}
            >
              <i
                className={`${link.icon} text-lg ${
                  link.highlight ? "text-emerald-400" : "text-blue-400"
                }`}
              ></i>
            </div>
            <div>
              <h2 className="font-semibold text-white mb-1">
                {lang === "bg" ? link.labelBg : link.labelEn}
              </h2>
              <p className="text-gray-400 text-sm">
                {lang === "bg" ? link.descBg : link.descEn}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );

  if (isLoggedIn) {
    return <PrivateLayout backgroundImage="/ww-wallpaper.webp">{content}</PrivateLayout>;
  }

  return (
    <PublicLayout>
      <div className="min-h-screen flex flex-col">
        <div
          className="fixed inset-0 -z-10"
          style={{
            backgroundImage: "url('/wow-wallpaper.jpg')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <div className="fixed inset-0 bg-black/70 -z-10 pointer-events-none" />
        {content}
      </div>
    </PublicLayout>
  );
}

export default Landing;
